module.exports = __webpack_public_path__ + "static/1-membership-benefit-4e62cce25b7fa2e348216fabfaa17160.png";